<template>
  <!--   This template would need to be cleaned up to remove the
  25px height from the Loading template but it creates artifacts
  This is due to the use of a template in a d-flex tag...
 -->
  <div
    :style="get_dimensions"
    class="lazy-table-horizontal-header h-100 d-inline-flex flex-column "
  >
    <template v-if="!loading">
      <div
        v-c-tooltip.hover="name"
        class="d-flex flex-row align-items-center justify-content-between flex-grow-0 flex-shrink-0"
        style="height:25px"
      >
        <span class="d-flex flex-row align-items-center">
          <span class="flex-shrink-0 float-left ml-2">
            <span :class="data_type_symbol" class="fa-xs" />
          </span>
          <span
            class="ml-1 d-flex flex-row align-items-center"
            @click="reset_sort"
          >
            <span v-if="sort_nb !== 0" class="text-primary">
              {{ sort_nb }}
            </span>
            <span
              v-if="sorting === 'ascending'"
              class="fas fa-long-arrow-alt-down text-primary"
            />
            <span
              v-if="sorting === 'descending'"
              class="fas fa-long-arrow-alt-up text-primary"
            />
          </span>
        </span>
        <span
          class="lazy-table-horizontal-header-title px-1 flex-w-stretch font-weight-bold text-truncate"
        >
          {{ name }}
        </span>

        <b-dropdown class="mr-2" variant="link" boundary="viewport">
          <b-dropdown-item-button @click="sort_up"
            >Sort Ascending</b-dropdown-item-button
          >
          <b-dropdown-item-button @click="sort_down"
            >Sort Descending</b-dropdown-item-button
          >
        </b-dropdown>
      </div>

      <columnstore-column-histogram
        :histogram="column_infos.histogram"
        :cell_width="width"
        :empty_percentage="column_infos.generic.nb_empty / nb_rows"
        :nb_obs="nb_rows"
      />
      <b-tooltip :target="uid" trigger="hover">
        <template v-if="column_infos.generic.nb_distinct === 1">
          unique value : {{ data_range[0] }}
        </template>
        <template v-else>
          <span>{{ data_range[0] }}</span>
          <span> &hellip; </span>
          <span>{{ data_range[1] }}</span>
          <div>{{ column_infos.generic.nb_distinct }} distinct values</div>
        </template>
      </b-tooltip>
      <div
        :id="uid"
        class="lazy-table-horizontal-header-title flex-shrink-0 d-flex flex-row"
        style="height: 20px; font-size:0.7em"
      >
        <div class="flex-w-stretch text-truncate">
          {{ data_range[0] }}
        </div>
        <template v-if="column_infos.generic.nb_distinct !== 1">
          <div>&hellip;</div>
          <div class="flex-w-stretch text-truncate">
            {{ data_range[1] }}
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <div
        class="lazy-table-horizontal-header-title d-flex flex-row align-items-center justify-content-between flex-grow-0 flex-shrink-0"
        style="height:25px"
      >
        Loading&hellip;
      </div>
      <div style="height: 94px;"></div>
    </template>
  </div>
</template>

<style lang="scss">
@import '@/custom-bootstrap.scss';

$header_height_total: 120px;
$header_height_top: 25px;
$header_height_middle: 75px;
$header_height_bottom: 20px;

.lazy-table-horizontal-header {
  background-color: white;
  color: $gray-900;
  border-left: 1px solid $gray-300;
  box-sizing: border-box;
}
.lazy-table-horizontal-header-title {
  font-size: medium;
  font-family: roboto mono, dejavu sans mono, courier, courier new, serif;
  text-align: center;
}
</style>

<script>
import _ from 'lodash'

import { display_format_element } from '@/components/columnstore_viewer_common.js'

import ColumnstoreColumnHistogram from '@/components/columnstore_column_histogram.vue'
import ColumnstoreViewerColumnFilter from '@/components/columnstore_viewer_column_filter.vue'

// *****************************************************************************

export default {
  name: 'ColumnstoreViewerColumnHeader',
  components: {
    ColumnstoreColumnHistogram,
    ColumnstoreViewerColumnFilter,
  },

  props: [
    'project_id',
    'poid',
    'name',
    'column_infos',
    'width',
    'height',
    'loading',
    'nb_rows',
    'sort',
  ],
  data() {
    return {
      uid: _.uniqueId('col_tooltip'),
    }
  },
  computed: {
    get_dimensions() {
      return 'box-sizing:border-box;'
    },
    data_type_symbol() {
      // let symbol_from_type = {
      //   float: ['far', 'fa-tally'],
      //   string: ['far', 'fa-text'],
      //   datetime: ['fal', 'fa-clock'],
      // }

      let symbol_from_type = {
        float: ['far', 'fa-tally'],
        string: ['far', 'fa-text'],
        datetime: ['fal', 'fa-clock'],
        bool: ['fas', 'fa-toggle-on'],
      }

      return symbol_from_type[this.column_infos.generic.category]
    },
    sort_nb() {
      return (this.sort || [])[0]
    },
    sorting() {
      return (this.sort || [])[1]
    },

    _() {
      return _
    },
    data_range() {
      let res = _.map(this.column_infos.generic.range, x =>
        display_format_element(
          x,
          this.column_infos.generic.category,
          this.column_infos.generic.body_display_format
        )
      )
      return res
    },
  },
  methods: {
    sort_up() {
      this.$emit('sort_up')
    },
    sort_down() {
      this.$emit('sort_down')
    },
    reset_sort() {
      this.$emit('reset_sort')
    },
  },
}
</script>
